/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const fundingInstructionDataSchema = z.object({
	accountHolder: z.string(),
	iban: z.string(),
	bic: z.string(),
	country: z.string(),
})

export type FundingInstructionDataSchema = z.infer<typeof fundingInstructionDataSchema>
